import { NgModule } from '@angular/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ChartModule } from 'angular2-chartjs';
import { NbCheckboxModule, NbCardModule, NbIconModule } from '@nebular/theme';

import { ComponentsModule } from '../../../../../../../@components/components.module';
import { GraphModule } from 'app/admin/public-foods/meal-metrics-graph/meal-metrics-graph.module';

import {
  MealPresentationReportComponent,
  MobileMealPresentationComponent,
  MealPresentationComponent,
} from './meal-presentation.component';
import { MealItemsPresentationModule } from '../MealItemsPresentation/meal-items-presentation.module';
import { MealItemPresentationModule } from '../MealItemPresentation/meal-item-presentation.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const NB_MODULES = [
  NbEvaIconsModule,
  NbIconModule,
  NbCheckboxModule,
  NbCardModule,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...NB_MODULES,
    GraphModule,
    ChartModule,
    ComponentsModule,
    MealItemPresentationModule,
    MealItemsPresentationModule,
  ],
  declarations: [
    MealPresentationReportComponent,
    MobileMealPresentationComponent,
    MealPresentationComponent,
  ],
  exports: [
    MealPresentationReportComponent,
    MobileMealPresentationComponent,
    MealPresentationComponent,
  ],
})
export class MealPresentationModule {}
